import { render, staticRenderFns } from "./SashAccessories.vue?vue&type=template&id=7a9549db&scoped=true&"
import script from "./SashAccessories.vue?vue&type=script&lang=js&"
export * from "./SashAccessories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9549db",
  null
  
)

export default component.exports